import { Base } from '@studiometa/js-toolkit';
import { addClass } from '@studiometa/js-toolkit/utils';

/**
 * Alert component
 */
export default class Alert extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Alert',
    refs: ['close'],
  };

  /**
   * Close Alert on close click
   */
  async onCloseClick() {
    this.$el.setAttribute('aria-hidden', 'true');
    addClass(this.$el, '-translate-y-full');
    setTimeout(() => {
      this.$el.remove();
    }, 600);
  }
}
